import React, { useMemo } from 'react';

import Linkify from 'react-linkify';

import { useTheme } from '../../context/ThemeProvider';
import { mentionRegex } from '../../shared/communityUtils';

type Props = {
  string: string;
  whiteSpaceNowrap?: boolean;
};

const RenderMentionText: React.FC<Props> = ({ string, whiteSpaceNowrap }) => {
  const { colors } = useTheme();
  const getNameFromMentiontag = (tag: string) =>
    tag.substring(tag.indexOf('#') + 1, tag.length - 2);

  const getIdFromMentiontag = (tag: string) =>
    tag.substring(2, tag.indexOf('#'));

  const textToRender = useMemo(() => {
    const text = string || '';
    const tagsRegexResult = `${text}`.match(mentionRegex);
    const tags: string[] = [];
    const nodes: React.ReactNode[] = [];

    tagsRegexResult?.forEach((element) => {
      tags.push(element);
    });

    if (tags?.length === 0) {
      const lines = text.split('\n');
      nodes.push(
        <span style={{ whiteSpace: whiteSpaceNowrap ? 'nowrap' : 'pre-wrap' }}>
          {lines.map((line, index) => (
            <React.Fragment key={index}>
              <Linkify>{line}</Linkify>
              {index < lines.length - 1 && <br />}
            </React.Fragment>
          ))}
        </span>,
      );
      return { nodes, text };
    }

    const commentText = text as string;
    const splits = commentText.split(mentionRegex);

    let newText = '';

    splits.forEach((textPart, index) => {
      const lines = textPart.split('\n');
      nodes.push(
        <span style={{ whiteSpace: whiteSpaceNowrap ? 'nowrap' : 'pre-wrap' }}>
          {lines.map((line, lineIndex) => (
            <React.Fragment key={`${index}-${lineIndex}`}>
              <Linkify>{line}</Linkify>
              {lineIndex < lines.length - 1 && <br />}
            </React.Fragment>
          ))}
        </span>,
      );
      newText += textPart;

      if (index < tags.length) {
        const tag = tags[index];
        const tagName = getNameFromMentiontag(tag);
        const mentionedUserId = getIdFromMentiontag(tag);

        newText += `@${tagName}`;

        nodes.push(
          <span
            key={mentionedUserId}
            role="button"
            tabIndex={0}
            // onClick={() => goToUserProfile(mentionedUserId)}
            style={{ color: colors.INFO_ALT, cursor: 'pointer' }}>
            <Linkify>@{tagName}</Linkify>
          </span>,
        );
      }
    });

    return { nodes, text: newText };
  }, [colors.INFO_ALT, string, whiteSpaceNowrap]);

  return <>{textToRender?.nodes}</>;
};

export default RenderMentionText;
